export module Enums {
  export enum DeviceActions {
    Lock = 0,
    Wipe = 1,
    Locate = 2,
    UnEnroll = 3,
    SendMessage = 4,
    ResetPasscode = 5,
    RemovePasscode = 6,
    CheckIn = 7,
  }

  export enum DeviceFamily {
    NotSpecified = 0,
    All = 1,
    WindowsCE = 2,
    iOS = 3,
    Android = 4,
    WindowsDesktop = 5,
    AndroidPlus = 6,
    Scanner = 7,
    WindowsPhone = 8,
    Blackberry = 9,
    Printer = 10,
    WindowsRuntime = 11,
    Linux = 12,
    Chrome = 13,
  }

  export enum DevicePlatform {
    Unknown = 1,
    WindowsCE = 100,
    WindowsMobile = 104,
    SmartPhone = 105,
    Android = 600,
    iOS = 700,
    macOS = 710,
    AndroidPlus = 800,
    WindowsPhone = 1000,
    WindowsRT = 1001,
    WindowsPhone81 = 1002,
    WindowsPhone10 = 1003,
    WindowsDesktop10 = 1004,
    WindowsPhoneMax = 1200,
    ZebraPrinter = 1300,
    WindowsRuntime = 1400,
    WindowsRuntimeMax = 1500,
    Linux = 1600,
  }

  export enum DeviceCompliance {
    JailbrokenOrRooted = 1,
    ManagementDisabledByUser = 2,
    Wiped = 3,
    DisabledByAdmin = 4,
    UnEnrolled = 5,
    IsEnrolled = 6,
  }

  export enum CompliancePolicyStatus {
    Pending = 0,
    NonCompliant = 1,
    Compliant = 2,
  }

  export enum DeviceType {
    DeviceAndroidForWork = 'DeviceAndroidForWork',
    DeviceAndroidElm = 'DeviceAndroidElm',
    DeviceAndroidKnox = 'DeviceAndroidKnox',
    DeviceAndroidPlus = 'DeviceAndroidPlus',
    DeviceAndroidGeneric = 'DeviceAndroidGeneric',
    DeviceIos = 'DeviceIos',
    DeviceMac = 'DeviceMac',
    DeviceWindowsCE = 'DeviceWindowsCE',
    DeviceWindowsDesktop = 'DeviceWindowsDesktop',
    DeviceWindowsDesktopLegacy = 'DeviceWindowsDesktopLegacy',
    DeviceWindowsPhone = 'DeviceWindowsPhone',
    DeviceWindowsRuntime = 'DeviceWindowsRuntime',
    DeviceZebraPrinter = 'DeviceZebraPrinter',
  }

  export enum MessageBoxTypes {
    Info = 0,
    Error = 1,
  }

  export enum MessageBoxButtons {
    OK = 1,
    Cancel = 2,
    Close = 4,
  }

  export enum ServerErrors {
    // Primary error types
    Unknown = 0,
    SecurityException = 1,
    BusinessLogicException = 2,

    // Extra flags for BusinessLogicException
    NotSupported = 4,
  }

  export enum AnalyticsEvent {
    MAP_READY = 'mapLoaded',
    CALCULATE_ROUTE_DIRECTION = 'calculateRoute',
    SEARCH_ADDRESS_REVERSE = 'getLocationAddress',
    SEARCH_FUZZY = 'searchLocation',
    TIME_ZONE_INFO = 'getTimeZoneInfo',
  }
}
